import { Navigate, createBrowserRouter } from 'react-router';
import { AdminAuthGuard } from './components/AdminAuthGuard';
import { AdminLayout } from './layouts/AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { OrgsPage } from './pages/OrgsPage';
import { OrgDetailPage } from './pages/OrgDetailPage';
import { UsersPage } from './pages/UsersPage';
import { PromotionsPage } from './pages/PromotionsPage';
import { PromotionDetailPage } from './pages/PromotionDetailPage';
import { AuditPage } from './pages/AuditPage';
import { BankHubPage } from './pages/BankHubPage';
import { PlatformConfigPage } from './pages/PlatformConfigPage';
import { BlogPostsPage } from './pages/BlogPostsPage';
import { BlogPostEditorPage } from './pages/BlogPostEditorPage';
import { BlogAuthorsPage } from './pages/BlogAuthorsPage';
import { NotFoundPage, RouteErrorPage } from './pages/RouteErrorPage';

export const router = createBrowserRouter([
  {
    // Pathless root purely to own `errorElement` — the net under every route
    // below. The catch-all at the end sits outside AdminAuthGuard so a wrong
    // URL says so instead of bouncing to the login form as if it were real.
    errorElement: <RouteErrorPage />,
    children: [
  { path: '/login', element: <LoginPage /> },
  {
    element: <AdminAuthGuard />,
    children: [
      {
        path: '/',
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="/orgs" replace /> },
          { path: 'orgs', element: <OrgsPage /> },
          { path: 'orgs/:id', element: <OrgDetailPage /> },
          { path: 'users', element: <UsersPage /> },
          { path: 'promotions', element: <PromotionsPage /> },
          { path: 'promotions/:id', element: <PromotionDetailPage /> },
          { path: 'bankhub', element: <BankHubPage /> },
          { path: 'config', element: <PlatformConfigPage /> },
          { path: 'audit', element: <AuditPage /> },
          { path: 'blog', element: <BlogPostsPage /> },
          { path: 'blog/new', element: <BlogPostEditorPage /> },
          { path: 'blog/authors', element: <BlogAuthorsPage /> },
          { path: 'blog/:id', element: <BlogPostEditorPage /> },
        ],
      },
    ],
  },

      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
